import { useEffect, useState, useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { subscribeRequestStatus, getRequestStatusSnapshot } from "../RequestStatus";

const ServerWaitIndicator = () => {
    const { t } = useTranslation();
    const { pending, since } = useSyncExternalStore(subscribeRequestStatus, getRequestStatusSnapshot);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        if (!pending) {
            return;
        }
        setSeconds(0);
        const interval = setInterval(() => {
            setSeconds(Math.floor((Date.now() - since) / 1000));
        }, 1000);
        return () => clearInterval(interval);
    }, [pending, since]);

    if (!pending) {
        return null;
    }

    return (
        <div className="serverWaitIndicator">
            {t('waitingForServer')} {seconds}s
        </div>
    );
};

export default ServerWaitIndicator;
